/* eslint-disable */
import { useEffect, useState } from 'react';
import type { FC, ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import { experimentalStyled } from '@material-ui/core/styles';
import DashboardNavbar from './DashboardNavbar';
import DashboardSidebar from './DashboardSidebar';
import useAuth from 'src/hooks/useAuth';
import ModalTour from './ModalTour';
import ModalPreUsed from './ModalPreUsed';
import ModalBankData from './ModalBankData';
import { IdleTimerProvider } from 'react-idle-timer';
import ModalTrade from "./ModalTrade";
import Cookies from "js-cookie";
interface DashboardLayoutProps {
  children?: ReactNode;
}

const DashboardLayoutRoot = experimentalStyled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  display: 'flex',
  height: '100%',
  overflow: 'hidden',
  width: '100%',
}));

const DashboardLayoutWrapper = experimentalStyled('div')(({ theme }) => ({
  display: 'flex',
  flex: '1 1 auto',
  overflow: 'hidden',
  paddingTop: '64px',
  paddingLeft: '80px',
  [theme.breakpoints.up('lg')]: {
    paddingLeft: '80px',
  },
}));

const DashboardLayoutContainer = experimentalStyled('div')({
  display: 'flex',
  flex: '1 1 auto',
  overflow: 'hidden',
});

const DashboardLayoutContent = experimentalStyled('div')({
  flex: '1 1 auto',
  height: '100%',
  overflow: 'auto',
  position: 'relative',
  WebkitOverflowScrolling: 'touch',
});

const DashboardLayout: FC<DashboardLayoutProps> = () => {
  const [isSidebarMobileOpen, setIsSidebarMobileOpen] =
    useState<boolean>(false);
  const { user, logout, isAuthenticated } = useAuth();
  const tradeAutomatico = Cookies.get('tradeAutomatico');

  const onIdle = () => {
    logout();
  };

  useEffect(() => {
    const handleInvalidToken = () => {
      // Your logout logic here
      logout();
    };
    window.addEventListener('storage', handleInvalidToken);
    return function cleanup() {
      window.removeEventListener('storage', handleInvalidToken);
    };
  }, [logout]);

  return (
    <>
      <IdleTimerProvider
        crossTab={true}
        syncTimers={1}
        timeout={1000 * 7200}
        onIdle={onIdle}
      >
        <DashboardLayoutRoot>
          <DashboardNavbar
            onSidebarMobileOpen={(): void => setIsSidebarMobileOpen(true)}
          />
          <DashboardSidebar
            onMobileClose={(): void => setIsSidebarMobileOpen(false)}
            openMobile={isSidebarMobileOpen}
          />
          <DashboardLayoutWrapper>
            <DashboardLayoutContainer>
              <DashboardLayoutContent>
                <Outlet />
              </DashboardLayoutContent>
            </DashboardLayoutContainer>
          </DashboardLayoutWrapper>
        </DashboardLayoutRoot>
        {/* Tour */}
        {user.isAdminUser !== true &&
          user.onboarding === true &&
          user.businessId?.flag_contract === false &&
          user.businessId?.firstStep === false && (<ModalTour />)}
        {/* Automatic Trade */}
        {
          (user.rol === 'master' || user.rol === 'estandar') && tradeAutomatico !== undefined ? <ModalTrade /> : <></>
        }
        {/* Contract */}
        {user.isAdminUser !== true && tradeAutomatico === null &&
          (user?.businessId?.firstStep === true ||
            user?.businessId?.firstStep === null) && <ModalPreUsed />}
        {/* Bank data */}
        {user.isAdminUser !== true &&
          user.rol === 'master' &&
          user.businessId.test_mode === false &&
          (user.businessId.bank_data === null ||
            user.businessId.bank_data === '') && <ModalBankData />}
      </IdleTimerProvider>
    </>
  );
};

export default DashboardLayout;
